<!-- CONTACT DETAILS on the contacts table ::: TODO This has to be just one component, not two as we have now. -->

<template>
  <div
    id="contact-details"
    class="full-height">

    <div class="user-details-box full-height">

      <ScrollArea
        ref="contactInfoScrollbar"
        class="scroll-area">
        <!-- Contact details on contacts table -->
        <h3>Contact info</h3>

        <div v-if="isLoadingData">
          <Spinner />
        </div>

        <div
          v-show="!isLoadingData"
          class="details-wrapper">
          <!-- <Last24HourCountdown
            class="countdown"
            :countdown-from="lastInboundMessageTime"/> -->
          <!-- Avatar -->
          <SBAvatar
            :show-client="true"
            :person="contact"
            :size="UserDropdownButtonSize.XXL" />

          <!-- Name -->
          <div
            class="contact-name"
            @click="checkPermission" >
            <textarea
              v-model="contact.name"
              v-autoheight
              placeholder="Add Name"
              :disabled="!hasPermissionToEdit"
              @input="changeContactData" />
          </div>

          <!-- Phone -->
          <div
            class="show-arrow flex flex-align-center flag-phone-wrapper">
            <Flag
              v-if="contact.meta_data.country"
              class="flag"
              :country="contact.meta_data.country.code"/>
            <p class="phone">{{ contact.phone | phoneFormat }}</p>
            <CopyNumber
              :value="contact.phone"
              class="big-copy"
              @click.native.stop />
          </div>

          <!-- Tags -->
          <div
            class="custom-field"
            @click="checkPermission" >
            <h5>Tags</h5>
            <template v-if="!contact.has_messaging_consent">
              <span
                :id="'status-unsubscribed'"
                class="status-unsubscribed optout-pill pr-0">
                Messaging disabled
                <SBIcon
                  :icon="SBIconList.INFO"
                  :color="SBColors.redPrimary"
                  :size="12" />
              </span>
              <b-popover
                :target="'status-unsubscribed'"
                triggers="hover"
                placement="bottom"
                boundary="window"
                custom-class="red">
                <h1 class="title">Contact opted-out</h1>
                <p>Contact opted-out from receiving messages from your number by sending opt-out keyword.</p>
              </b-popover>
            </template>
            <div
              style="margin-bottom: -4px;"
              @click="$refs.tagsMultiselectRef.activate()">
              <span
                v-for="(tag, index) in contact.tags.filter(t => !t.editable)"
                :id="'cd-tag-pill-' + contact.id + tag.index"
                :key="index"
                class="multiselect__tag no-edit inline flex flex-align-center">
                <img
                  v-if="tag.icons"
                  :src="tag.icons.dark"
                  style="height: 11px; margin-right: 4px;" >
                <span>{{ tag.name }}</span>
                <b-popover
                  v-if="tag.name.toLowerCase() === 'undeliverable'"
                  :target="'cd-tag-pill-' + contact.id + tag.index"
                  triggers="hover"
                  placement="top"
                  boundary="window"
                  custom-class="big blue-href">
                  <h1 class="title">Undeliverable WhatsApp Messages</h1>
                  <p>
                    It was not possible to send a message to this contact. One possible reason could be that the recipient is not on WhatsApp. Learn more about undeliverable messages
                    <a
                      href="https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/#other-errors"
                      target="_blank">here</a>. Try sending a message again to see if the contact will receive it.</p>
                </b-popover>
              </span>
            </div>
            <!-- TODO - Create custom component for tag handling because using multiselect requires too much hacks. -->
            <multiselect
              ref="tagsMultiselectRef"
              v-model="contactTags"
              :options="availableTags"
              :multiple="true"
              :taggable="true"
              :hide-selected="true"
              :show-labels="false"
              :show-no-results="false"
              :option-height="130"
              open-direction=""
              tag-placeholder=""
              :disabled="!hasPermissionToEdit"
              placeholder="Add a tag"
              label="name"
              track-by="id"
              class="tag-multiselect"
              :class="{'already-selected': alreadySelected, 'create': tagHeaderTitle === 'Create'}"
              @search-change="tagsFindTagMatch"
              @tag="tagsAddNewTag"
              @select="addTag"
              @remove="removeTag">
              <div
                slot="beforeList"
                class="multiselect-title">
                {{ tagHeaderTitle }}
              </div>
              <div
                slot="noOptions"
                ref="hideParent" />
              <div
                v-if="hasNextPage"
                slot="afterList"
                class="multiselect-title">
                <div
                  v-observe-visibility="endOfTagsList">
                  <Spinner
                    :size="17"
                    :thickness="2" />
                </div>
              </div>
            </multiselect>
          </div>

          <!-- Custom fields -->
          <div
            v-for="customField in customFieldList[organisationId]"
            :key="customField.name"
            class="custom-field">
            <h5>{{ customField.name }}</h5>
            <CustomField
              v-model="contactCustomFields[customField.id]"
              :fieldp="customField"
              @input="syncCustomFields(customField.id)"/>
          </div>

        </div>
      </ScrollArea>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'debounce';
import Multiselect from 'vue-multiselect';

import api from '@/helpers/api';
import Spinner from '../../../common/Spinner';
import ScrollArea from '../../../common/ScrollArea';
import Flag from '../../../common/Flag';
import SBAvatar from '../../../common/Avatar';
import UserDropdownButtonSize from '../../../../helpers/lists/userDropdownButtonSize';
import CustomField from '../../contacts/partials/CustomField';
import Last24HourCountdown from '@/components/business/chat/partials/Last24HourCountdown';
import ContactDetailsControl from '../Control';
import SBIcon from '../../../common/Icon';
import SBIconList from '../../../../helpers/lists/sb-icon-list';
import SBColors from '../../../../helpers/lists/colors';
import ToasterMixin from '@/mixins/Toaster';
import CopyNumber from '../../../common/CopyNumber';

export default {
  name: 'ContactDetails',
  components: {
    Multiselect,
    ScrollArea,
    Flag,
    Last24HourCountdown,
    Spinner,
    SBAvatar,
    CustomField,
    CopyNumber,
    SBIcon,
  },
  directives: {
    autoheight: {
      // TODO create global directive
      update: function f(el) {
        el.style.height = '16px';
        el.style.height = `${el.scrollHeight}px`;
      },
    },
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      UserDropdownButtonSize,
      alreadySelected: false,
      initialized: false,
      tagsSearchQuery: '',
      availableTags: [],
      tagPage: 0,
      maxTagPages: null,
      loadingTagsForId: null,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      vuexLoadingContact: 'contactDetails/contactDataIsLoading',
      /* *
       * note:
       * when using vuex mapGetters to map contactDetails/contactData we get a computed property `contact`
       * in template we would 2-way-bind some property like name with v-model="contact.name"
       * editing that value in HTML attempts to set a computed property
       * that creates a component-scoped contact property
       */
      contact: 'contactDetails/contactData',
      vuexAllContactTags: 'contactTag/list',

      customFieldList: 'contact/customFieldList',
      loadingCustomFields: 'contact/loadingCustomFields',
      contactTagCreated: 'contact/contactTagCreated',

      currentOrganisation: 'organisation/currentOrganisation',
    }),
    // shorthand
    businessId() {
      return this.contact && this.contact.business;
    },
    contactTags: {
      get() {
        return this.contact.tags.filter(t => t.editable);
      },
      set(val) {
        this.contact.tags = [...this.contact.tags.filter(t => !t.editable), ...val];
      },
    },
    hasPermissionToEdit() {
      return this.$hasPermissionInOrganisation('can_edit_contact');
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
    isLoadingData() {
      return this.vuexLoadingContact || (!this.initialized && this.loadingCustomFields);
    },
    selectedTags() {
      return this.contact.tags.map(tag => tag.name.toLowerCase());
    },
    tagHeaderTitle() {
      let title = 'All tags';
      const tagAlreadyAdded = this.contact.tags.some(tag => tag.name.toLowerCase() === this.tagsSearchQuery.toLowerCase());

      if (tagAlreadyAdded) {
        title = 'Start typing to add a tag';
      } else {
        const containedInTheOptions = this.availableTags.filter(tag => !this.selectedTags.includes(tag.name.toLowerCase()))
          .some(tag => tag.name.toLowerCase().indexOf(this.tagsSearchQuery.toLowerCase()) >= 0);
        if (!containedInTheOptions) {
          title = 'Create';
        }
      }

      return title;
    },
    contactCustomFields() {
      return this.contact.meta_data.custom_fields;
    },
    lastInboundMessageTime() {
      return this.contact.inbound_sent_at || '';
    },
    hasNextPage() {
      return this.maxTagPages === null || this.tagPage < this.maxTagPages;
    },
  },
  watch: {
    contact(newData) {
      this.loadMoreTags(true);

      // whenever contact changes, update business custom fields
      // @todo: this should be upgraded so only one request is made per businessId
      // if (newData.business) {
      //   this.fetchCustomFields({
      //     organisationId: this.$route.params.organisationId,
      //   });
      // }
    },
    loadingCustomFields() {
      if (!this.loadingCustomFields) {
        this.initialized = true;
      }
    },
  },
  mounted() {
    this.loadMoreTags(true);
    // if (!this.customFieldList.length && this.businessId) {
    //   this.fetchCustomFields({
    //     organisationId: this.$route.params.organisationId,
    //   });
    // }
    // // ensure all tags are loaded
    // if (!this.vuexAllContactTags.length) {
      // this.vuexFetchOrganisationTags({
      //   organisationId: this.organisationId,
      //   businessId: this.businessId,
      // });
    // this.getTags();
    // }

    // There is no "showNoOptions" option on the vue multiselect which is expected but in this case we need not to show the options empty list item and we cant use display solet's just set the height at 0.
    this.$refs.hideParent.parentElement.parentElement.style.height = 0;
  },
  methods: {
    ...mapActions({
      vuexFetchOrganisationTags: 'contactTag/fetchOrganisationContactTags',
      vuexCreateContactTag: 'contactTag/createContactTag',
      vuexSyncContactTags: 'contactDetails/syncContactTags',
      vuexAddContactTagWhenCreated: 'contactDetails/addContactTagWhenCreated',
      // fetchCustomFields: 'contact/fetchCustomFields20',
      syncContactCustomFields: 'contact/syncContactCustomFields',
      updateCustomField: 'contact/updateCustomField',
      vuexUpdateContact: 'contact/updateContact',
      addUserTag: 'contactTag/addUserTag',
      deleteUserTag: 'contactTag/deleteUserTag',
    }),
    endOfTagsList(reached) {
      if (reached) {
        this.loadMoreTags();
      }
    },
    loadMoreTags(reset = false) {
      if (reset) { // When resetting a contact with different business id
        this.tagPage = 0;
        this.loadingTagsForId = this.contact.business;
        this.maxTagPages = null;
        this.availableTags = [];
        // if (this.contact.has_messaging_consent) {
        //   this.availableTags.push()
        // }
      }

      this.tagPage++;
      if (this.maxTagPages !== null && this.tagPage > this.maxTagPages) {
        return;
      }
      const data = {
        limit: 50,
        page: this.tagPage,
        name: this.tagsSearchQuery,
        editable: true,
        noCancel: true,
      };
      api('GET', `organisation/${this.currentOrganisation.id}/contact-tags`, data, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            this.availableTags = [...this.availableTags, ...response.data.data];
            this.maxTagPages = response.data.meta.last_page;
          }
        })
        .catch((error) => {
          this.maxTagPages = 0;
        });
    },
    tagsFindTagMatch: debounce(function f(tagsSearchQuery) {
      this.tagsSearchQuery = tagsSearchQuery;
      this.alreadySelected = this.selectedTags.includes(tagsSearchQuery.toLowerCase());
      this.loadMoreTags(true);
    }, 500),
    /**
     * Adds tag to a user.
     */
    addTag(selectedTag) {
      this.addUserTag({
        contactId: this.contact.id,
        organisationId: this.organisationId,
        tags: [{
          id: selectedTag.id,
          name: selectedTag.name,
        }],
        data: {
          tags: selectedTag.id,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            ContactDetailsControl.emitContactDataChange(this.contact.id, { tags: this.contact.tags });
          }
        });
    },
    removeTag(removedTag) {
      if (!removedTag) {
        return;
      }
      this.deleteUserTag({
        contactId: this.contact.id,
        organisationId: this.organisationId,
        tags: [{
          id: removedTag.id,
          name: removedTag.name,
        }],
        data: {
          tags: removedTag.id,
        },
      });
      this.$nextTick(() => {
        ContactDetailsControl.emitContactDataChange(this.contact.id, { tags: this.contact.tags });
      });
    },
    tagsAddNewTag(newTagName) {
      // add new ag to list of tags right away so it's displayed - we'll update it with a proper ID later
      this.contact.tags.push({ id: '', name: newTagName, editable: true });
      ContactDetailsControl.emitContactDataChange(this.contact.id, { tags: this.contact.tags });

      const newTagPayload = {
        organisationId: this.organisationId,
        businessId: this.businessId,
        data: {
          name: newTagName,
        },
      };
      // an agent might add a new tag and then select another contact
      // we need to be careful with async calls
      // this.vuexCreateContactTag(payload).then((tagData){ this.storeSyncContactContactTag(....); });
      // will cause the new contactTag to be added to the wrong contact (since `this.contact` changed)
      // so, store action will keep track of state that needs to be passed to backend

      // this has to be IIFE since this.contact might change
      // eslint-disable-next-line wrap-iife
      const notifyStore = (function (org, contact, vuexAddContactTagWhenCreated, addUserTag) {
        return function (createdTagData) {
          vuexAddContactTagWhenCreated({
            organisationId: org,
            contactId: contact,
            data: {
              tags: [createdTagData.id],
            },
          });
          addUserTag({
            contactId: contact,
            organisationId: org,
            tags: [{
              id: createdTagData.id,
              name: createdTagData.name,
            }],
            data: {
              tags: createdTagData.id,
            },
          });
        };
      })(this.organisationId, this.contact.id, this.vuexAddContactTagWhenCreated, this.addUserTag);

      this
        .vuexCreateContactTag(newTagPayload)
        .then((createdTagData) => {
          // update tag id in current list
          const tag = this.contact.tags.find(t => t.name.toLowerCase() === createdTagData.name.toLowerCase());
          if (tag) {
            tag.id = createdTagData.id;
          }
          // sync contact tags with backend
          notifyStore(createdTagData);
        });
    },
    /**
     * TODO this should be changed to only updates one specific field.
     *      This setup overwrites the fields if two agents edit any field at the same time.
     */
    syncCustomFields: debounce(function f(customFieldId) {
      const fieldsToSync = {};
      if (this.isObject(this.contactCustomFields[customFieldId]) && this.contactCustomFields[customFieldId].value !== 'undefined') {
        fieldsToSync[customFieldId] = this.contactCustomFields[customFieldId].value;
      } else {
        fieldsToSync[customFieldId] = (typeof this.contactCustomFields[customFieldId] === 'undefined') ? null : this.contactCustomFields[customFieldId];
      }
      const payload = {
        organisationId: this.organisationId,
        merchant_id: this.businessId,
        contact_id: this.contact.id,
        data: {
          custom_fields: fieldsToSync,
        },
      };

      this.$nextTick(() => {
        this.syncContactCustomFields(payload);
      });
    }, 1000),
    changeContactData() {
      // trigger change event on Control
      ContactDetailsControl.emitContactDataChange(this.contact.id, { name: this.contact.name });

      this.syncContactData();
    },
    syncContactData: debounce(function f() {
      const payload = {
        merchant_id: this.businessId,
        contact_id: this.contact.id,
        organisationId: this.organisationId,
        data: {
          name: this.contact.name,
          phone: this.contact.phone,
        },
      };

      this.vuexUpdateContact(payload);
    }, '1000'),
    getTags() {
      this.vuexFetchOrganisationTags({
        organisationId: this.organisationId,
        businessId: this.businessId,
      });
    },
    checkPermission() {
      if (!this.hasPermissionToEdit) {
        this.showToaster('You don’t have a permission to do this action.', null, null, 'warning');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#contact-details {
  width: $detailsSidebarWidth;

  h5 {
    cursor: default;
    margin-bottom: 3px !important;
    overflow-wrap: anywhere;
  }

  .label-wrapper {
    margin-bottom: 6px;

    h5 {
      margin-left: 5px !important;
      margin-bottom: 0px !important;
    }
  }
}
.details-wrapper {
  margin: 0 15px 15px;
  padding: 15px 12px;
  background: $white;
  border: 1px solid $greyBorderModal;
  border-radius: 5px;
  position: relative;

  .countdown {
    position: absolute;
    right: 12px;
    top: 15px;
  }

  .contact-name {
    font-size: 20px;
    color: $blackPrimary;
    margin-top: 10px;
    position: relative;

    input, textarea {
      width: 100%;
      border: none;
      outline: none;
      font-size: 20px;
      line-height: 1.1;
      color: $blackPrimary;
      margin: 0;
      padding: 0;
      background-color: unset;
      box-shadow: none !important;
      resize: none;
      overflow: hidden;
      //height: 5px;

      &:active, &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }

    .fa-icon {
      position: absolute;
      top: 20px;
      right: 0;
      opacity: 0;
      transition: all 0.2s ease;
    }
  }

  .flag-phone-wrapper {
    margin-bottom: 5px;

    .phone {
      margin-left: 2px;
      font-size: 14px;
      line-height: 1.2;
      color: $blackUltralight;
    }
  }

  .custom-field {
    padding-top: 14px;

    h5 {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.1;
      color: $blackUltralight;
      margin-bottom: 6px;
    }

    .multiselect--disabled, ::v-deep input:disabled {
      background-color: $white !important;
    }
  }

  .tag-multiselect {
    &:hover {
      box-shadow: none !important;
    }
  }
}

.content {
  .contact-name {
    font-size: 20px;
    color: $blackPrimary;
    margin-top: 15px;
    margin-bottom: 5px;

    position: relative;
    input {
        width: 100%;
      border: none;
      outline: none;
      font-size: 20px;
      color: $blackPrimary;
      margin: 15px 0 5px 0;
      padding: 0;
      background-color: unset;
    }

    .fa-icon {
      position: absolute;
      top: 20px;
      right: 0;
      opacity: 0;
      transition: all 0.2s ease;
    }

    &:hover .fa-icon {
      opacity: 1;
    }
  }

  h5, .custom-field h5 {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    color: $blackUltralight;
    margin-top: 15px;
    margin-bottom: 6px;
  }

  .multiselect {
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    line-height: 1.2;
    color: $blackPrimary;
  }

  .flag {
    margin-right: 4px;
  }

  .custom-field {
    h5 {
      margin: 0 !important;
    }
  }
}

.optout-pill {
  background-color: #fbe4e5;
  color: #ff5b61;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  padding: 0 8px;
  height: 20px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  margin: 4px 5px 4px 0;
  cursor: pointer;

  div.sb-icon {
    margin-left: 6px;
    margin-right: 4px;
  }
}

::v-deep .multiselect {
  margin-top: 6px;

  .multiselect__tags {
    flex-direction: column;
    align-items: flex-start;
  }

  .multiselect__content-wrapper {
    min-height: 40px;
  }
}

// .multiselect.tag-multiselect .multiselect__tags .multiselect__tags-wrap .multiselect__tag>span {
//   margin: 0 5px 0 0;
// }

.multiselect__tag {
  cursor: default;
  margin: 0 5px 2px 0;
  padding: 3px 6px 3px 8px;
  border-radius: 11px;
  background-color: #edf0f2;

  &>span {
    margin: 0 0 0 0;
    font-size: 12px !important;
    font-weight: 500;
    line-height: 1.22;
    color: $blackPrimary;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}
</style>
